import { MailIcon } from 'lucide-react';
import { useAuth } from '../../hooks';
import { Alert } from '../common';

interface MagicLinkSentProps {
  linkLabel: string;
}

export function MagicLinkSent({ linkLabel }: MagicLinkSentProps) {
  const { sendMagicLink, resetMagicLink, magicLinkEmail, loading, error } = useAuth();

  const handleResend = async () => {
    if (!magicLinkEmail) return;
    try {
      await sendMagicLink(magicLinkEmail);
    } catch {
      // Error is handled by useAuth
    }
  };

  return (
    <div className="text-center">
      {error && (
        <Alert variant="error" className="mb-4">{error}</Alert>
      )}

      <div className="w-12 h-12 mx-auto mb-4 bg-success/20 rounded-full flex items-center justify-center">
        <MailIcon className="size-6 text-success" />
      </div>
      <h2 className="text-base-content mb-2">Check your email</h2>
      <p className="text-base-content/80 mb-6">
        We sent a {linkLabel} to <span className="font-medium text-base-content">{magicLinkEmail}</span>.
        The link expires in 15 minutes.
      </p>

      <button
        onClick={handleResend}
        disabled={loading}
        className="btn btn-outline w-full"
      >
        {loading ? 'Sending...' : 'Resend link'}
      </button>

      <div className="mt-4">
        <button
          onClick={resetMagicLink}
          className="link link-primary text-sm"
        >
          Use a different email
        </button>
      </div>
    </div>
  );
}
